import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import { EditableText } from "../../EditableText";
import type { PDFPreviewFormData } from "../pdfPreview.types";

interface PDFHeaderInfoEditorProps {
  control: Control<PDFPreviewFormData>;
}

export function PDFHeaderInfoEditor({ control }: PDFHeaderInfoEditorProps) {
  return (
    <>
      {/* Editable Title */}
      <Controller
        name="title"
        control={control}
        render={({ field: { onChange, value } }) => (
          <EditableText
            value={value}
            onChange={onChange}
            displayAs="h1"
            displayClassName="text-2xl font-bold text-center mb-10"
            editClassName="text-2xl font-bold text-center mb-10 w-full"
          />
        )}
      />

      {/* Project Details - Two Column Layout */}
      <Controller
        name="headerInfo"
        control={control}
        render={({ field: { value: headerInfo, onChange } }) => (
          <div className="mb-8 space-y-2 text-sm">
            {headerInfo.map((item, index) => (
              <div key={index} className="grid grid-cols-[140px_1fr] gap-4">
                {/* Editable key (label) */}
                <EditableText
                  value={item.key}
                  onChange={(newKey) => {
                    const updated = [...headerInfo];
                    updated[index] = { ...updated[index], key: newKey };
                    onChange(updated);
                  }}
                  displayClassName="font-bold"
                  editClassName="font-bold"
                />
                {/* Editable value */}
                <EditableText
                  value={item.value || ""}
                  onChange={(newValue) => {
                    const updated = [...headerInfo];
                    updated[index] = { ...updated[index], value: newValue };
                    onChange(updated);
                  }}
                />
              </div>
            ))}
          </div>
        )}
      />
    </>
  );
}
